import { connect } from 'react-redux';

import LearningAdminHeaderScreen from '../components/LearningAdminHeaderScreen';
import { moduleSerieAdminShowPreviewDetail } from '../../../../../state/modules/learningsAdmin/actions';

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    showDetail: () => {
      dispatch(moduleSerieAdminShowPreviewDetail());
    },
  };
};

const LearningAdminHeaderScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminHeaderScreen);

export default LearningAdminHeaderScreenContainer;
